import {
  STOCKING_APPLE_FAQ,
  STOCKING_APPLE_FALLBACK_IMAGE,
  STOCKING_APPLE_PATH,
  STOCKING_APPLE_PRODUCT_PATH,
  STOCKING_APPLE_PRODUCT_SLUG,
} from '../data/stockingAppleCream'
import { getProductPrimaryImageUrl, getStorefrontConfig, getStorefrontProduct, toExternalImage } from './dropify'
import { INDEXABLE_ROBOTS, absoluteUrl, buildBreadcrumbSchema, buildFaqSchema } from './seo'

const title = 'Grosir Stocking Apple B08B Cream untuk Stok Toko | Dropify'
const description = 'Cari Stocking Celana Apple B08B warna cream untuk stok toko? Cek ukuran, bahan, MOQ, stok, harga grosir, dan ongkir melalui WhatsApp Dropify.'
const imageOptions = { width: 1200, height: 1200, fitIn: true, format: 'webp', quality: 82 } as const

export async function loadStockingAppleCream() {
  const [config, product] = await Promise.all([
    getStorefrontConfig().catch(() => null),
    getStorefrontProduct(STOCKING_APPLE_PRODUCT_SLUG).catch(() => null),
  ])
  const primaryImage = product ? getProductPrimaryImageUrl(product) : null
  const image = toExternalImage(primaryImage ?? STOCKING_APPLE_FALLBACK_IMAGE, imageOptions)
  return { config, image }
}

export function stockingAppleCreamHead(data?: Awaited<ReturnType<typeof loadStockingAppleCream>>) {
  const image = data?.image ?? toExternalImage(STOCKING_APPLE_FALLBACK_IMAGE, imageOptions)
  return {
    meta: [
      { title },
      { name: 'description', content: description },
      { name: 'robots', content: INDEXABLE_ROBOTS },
      { property: 'og:type', content: 'product' },
      { property: 'og:locale', content: 'id_ID' },
      { property: 'og:title', content: title },
      { property: 'og:description', content: description },
      { property: 'og:url', content: absoluteUrl(STOCKING_APPLE_PATH) },
      { property: 'og:image', content: image },
      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:title', content: title },
      { name: 'twitter:description', content: description },
      { name: 'twitter:image', content: image },
    ],
    links: [{ rel: 'canonical', href: absoluteUrl(STOCKING_APPLE_PATH) }],
    scripts: [
      buildBreadcrumbSchema([
        { name: 'Beranda', path: '/' },
        { name: 'Stocking Celana Apple B08B', path: STOCKING_APPLE_PRODUCT_PATH },
        { name: 'Stocking Apple cream', path: STOCKING_APPLE_PATH },
      ]),
      buildFaqSchema(STOCKING_APPLE_FAQ),
    ].map((schema) => ({ type: 'application/ld+json', children: JSON.stringify(schema) })),
  }
}
